import { createContext, useMemo, useState } from "react"
import React from "react"
import { ACTIONS, EVENTS, STATUS } from "react-joyride"
import { useAppDispatch, useAppSelector } from "../redux/hooks"
import { getUserProfile, updateUserGuide } from "../redux/action"
import "./Tour.scss"
const TourContext = createContext({})

export const TourProvider = ({ children }: any) => {
  const dispatch = useAppDispatch()

  const { userDetail }: any = useAppSelector((state: any) => state.auth)

  const [{ run, accordionOpen, steps, isRestart }, setState] = useState<any>({
    run: true,
    isRestart: false,
    accordionOpen: false,
    modelOpen: false,
    steps: [
      {
        content: (
          <div>
            <h2>Welcome to ROI Navigator</h2>
            <h5>Get Started with ROI Navigator</h5>
            <p className="tour-p tour-div ">
              Begin your journey with ROI Navigator. This tool is designed to
              help you efficiently estimate and track your return on investment
              (ROI). Lets walk through the features and functionalities to get
              you up to speed.
            </p>
          </div>
        ),
        placement: "center",
        target: ".ROI_Estimate",
        spotlightClicks: false,
      },
      {
        content: (
          <div className="tour-div">
            <p className="tour-p">
              On this page, you'll find a comprehensive list of previous ROI
              estimates, along with an option to create a new one.
            </p>
          </div>
        ),
        placement: "bottom",
        target: ".ROI_Estimate",
        title: "Understand Your ROI",
        disableOverlay: true,
      },

      {
        content: (
          <div className="tour-div">
            <p className="tour-p">
              ClicK on the "List View" to see the ROI estimates organized by
              customer name.{" "}
            </p>
          </div>
        ),
        placement: "bottom",
        disableOverlay: true,
        styles: {
          options: {
            zIndex: 10000,
          },
        },
        target: ".accordion-367",
        title: "View ROI by Customer",
      },
      {
        content: (
          <div className="tour-div">
            <p className="tour-p">
              Click on the link showing the ROI name to open a new window for
              that specific ROI. Here, you can view all the particulars and
              details related to that ROI.{" "}
            </p>
          </div>
        ),
        placement: "bottom",
        disableOverlay: true,
        target: ".MuiDataGrid-row--firstVisible div",
        title: "Open ROI Details",
      },
      {
        content: (
          <div className="tour-div">
            <p className="tour-p">
              ClicK on "Action" in the ROI list to access additional actions
              that can be performed on the currently created ROI.
            </p>
          </div>
        ),
        placement: "left",
        disableOverlay: true,
        target: ".MuiDataGrid-row--firstVisible .kebab-menu",
        title: "Access Additional Actions",
      },
      {
        content: (
          <div className="tour-div">
            <p className="tour-p">
              The additional actions available for each ROI include: <br />
              1) Edit Product : Modify the selection of products associated with
              the ROI.
              <br />
              2) Edit: Make changes to the details and parameters of the ROI.
              <br />
              3) Clone:Duplicate the current ROI, creating a copy for further
              <br />
              analysis or modification.
            </p>
          </div>
        ),
        placement: "left",
        disableOverlay: true,
        target: ".MuiList-root.custom-menu-list-class",
        title: "Additional Options for ROI Management",
      },
      {
        content: (
          <div className="tour-div">
            <p className="tour-p">
              Click on the left side panel to reveal additional options. This
              panel provides further functionalities and settings related to
              your ROI management.
            </p>
          </div>
        ),
        placement: "right",
        disableOverlay: true,
        target: ".my-sidebar",
        title: "Explore More Options",
      },
      {
        content: (
          <div className="tour-div">
            <p className="tour-p">
              Need a Refresh? You can restart this guide at any time by clicking
              on the "Step by Step Guide" icon. This allows you to revisit any
              step and ensure you’re getting the most out of the ROI Navigator
            </p>
          </div>
        ),
        placement: "top",
        disableOverlay: true,
        target: ".step_by",
        title: "Restart the Walkthrough Anytime",
      },
      {
        content: (
          <div className="tour-div">
            <p className="tour-p">
              Click on the "Create ROI" button to enter the ROI wizard. This is
              a step-by-step guide to help you create a new ROI with ease.
            </p>
          </div>
        ),
        disableOverlay: true,
        placement: "left",
        target: ".EstimateButton",
        title: "Start New ROI Creation",
      },
      {
        content: (
          <div className="tour-div">
            <p className="tour-p">
              Select products from Aternity, IQ, or any combination of them to
              proceed further in the ROI creation process.
            </p>
          </div>
        ),
        placement: "top",
        disableOverlay: true,
        target: ".product-model-butn",
        title: "Choose Your Products",
      },
      {
        title: "Navigate Through the ROI Wizard",
        content: (
          <div className="tour-div">
            <p className="tour-p">
              Enter the ROI wizard interface, where you'll be guided through the
              different steps of creating a new ROI.
            </p>
          </div>
        ),
        target: ".MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel",
        placement: "bottom",
        disableOverlay: false,
      },

      {
        title: "Modify Product Selection",
        content: (
          <div className="tour-div">
            <p className="tour-p">
              At any point during the wizard, you can edit the selected products
              by clicking the edit icon.
            </p>
          </div>
        ),
        target: ".product-editbtn",
        disableOverlay: true,
      },
      {
        title: "Confirmm Product Selection",
        content: (
          <div className="tour-div">
            <p className="tour-p">
              After making changes to the product selection, click on the
              "Apply" button to proceed with the new selection of products.
            </p>
          </div>
        ),
        target: ".product-model-edit-butn",
        disableOverlay: true,
      },
      {
        title: "Customize Your Assumptions",
        content: (
          <div className="tour-div">
            <p className="tour-p">
              Tailor Your ROI Assumptions Select the method for personalizing
              your assumptions: Manual, Industry Low, Industry Average, or
              Industry High. This step allows you to tailor the ROI estimates to
              better reflect your specific scenario or industry standards.
            </p>
          </div>
        ),
        target: ".assum-input",
        disableOverlay: true,
      },
      {
        title: "Calculation Without Riverbed",
        content: (
          <div className="tour-div">
            <p className="tour-p">
              Click on "Without Riverbed" to view the ROI calculation without
              considering the impact of Riverbed products.
            </p>
          </div>
        ),
        target: ".Without_Riverbed",
      },
      {
        title: "Calculate With Riverbed",
        content: (
          <div className="tour-div">
            <p className="tour-p">
              Click on "With Riverbed" to view the ROI calculation including the
              impact of Riverbed products.
            </p>
          </div>
        ),
        target: ".withRiverbed",
        disableOverlay: true,
      },
      {
        title: "Explore Savings with Riverbed",
        content: (
          <div className="tour-div">
            <p className="tour-p">
              Click on "Savings" to view the calculated savings achieved with
              Riverbed products.
            </p>
          </div>
        ),
        target: ".savings",
        disableOverlay: true,
      },
      {
        title: "Click on Generate ROI",
        content: (
          <div className="tour-div">
            <p className="tour-p">
              Click on "Generate ROI" to obtain a comprehensive summary report
              of the ROI calculation. Once clicked, you cannot go back to edit
              the current ROI, so ensure all information is accurate before
              proceeding.
            </p>
          </div>
        ),
        target: ".complet-button",
        disableOverlay: true,
      },
      {
        title: "Edit Your PDF Content",
        content: (
          <div className="tour-div">
            <p className="tour-p">
              Customize Your ROI Report In this step, you can edit the content
              of your ROI report PDF. Modify text, adjust layouts, and include
              additional information to ensure accurate report.
            </p>
          </div>
        ),
        target: ".pdf-button",
        disableOverlay: true,
      },

      {
        title: "Confirmation to Proceed",
        content: (
          <div className="tour-div">
            <p className="tour-p">
              After generating the ROI summary, a pop-up will appear asking you
              to confirm your decision. Click on "Yes, I am sure" to proceed
              further with the finalized ROI calculation.
            </p>
          </div>
        ),
        target: ".confim-save-roi",
        disableOverlay: true,
      },
      {
        title: "Generate Comprehensive ROI Report",
        content: (
          <div className="tour-div">
            <p className="tour-p">
              Click on "Download ROI Report" to generate a comprehensive ROI
              report in PDF format. This report will contain detailed
              information about the ROI calculation, including metrics, and
              analysis. Downloading the report allows you to save and share it
              for further review or presentation purposes.
            </p>
          </div>
        ),
        target: ".roi-buttn",
        placement: "bottom",
        disableOverlay: true,
      },
    ],
  })

  useMemo(() => {
    if (userDetail.isGuideCompleted && !isRestart) {
      setState((prev: any) => ({
        ...prev,
        run: !userDetail.isGuideCompleted,
        accordionOpen: true,
      }))
    }

    if(!userDetail.isGuideCompleted && !isRestart){
      setState((prev: any) => ({
        ...prev,
        run: true,
      }))
    }
  }, [userDetail, run])

  const [stepIndex, setStepIndex] = useState(0)

  const handleJoyrideCallback = (data: any) => {
    const { action, index, status, type } = data

    if (action === ACTIONS.CLOSE || action === ACTIONS.SKIP) {
      setState((prev: any) => ({ ...prev, run: false, accordionOpen: false }))
      if (!userDetail.isGuideCompleted) {
        const formData: any = new FormData()
        formData.append("isGuideCompleted", true)
        dispatch(updateUserGuide(formData))
        dispatch(getUserProfile())
      }
      return
    }

    if (
      [EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type) &&
      !isRestart
    ) {
      // Update state to advance the tour
      if ((index === 9 || index === 13 || index === 17) && !accordionOpen) {
        setState((prev: any) => ({ ...prev, run: false, accordionOpen: false }))
        setTimeout(() => {
          setState((prev: any) => ({ ...prev, run: true, accordionOpen: true }))
          setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1))
        }, 100)
      } else if (
        (index === 10 || index === 14 || index === 18) &&
        accordionOpen &&
        EVENTS.TARGET_NOT_FOUND
      ) {
        setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1))
        setState((prev: any) => ({
          ...prev,
          run: true,
          accordionOpen: userDetail.isGuideCompleted ? true : false,
        }))
      } else {
        setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1))
      }
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // You need to set our running state to false, so we can restart if we click start again.
      setState((prev: any) => ({
        ...prev,
        run: false,
        accordionOpen: userDetail.isGuideCompleted ? true : false,
      }))
    } else if (isRestart) {
      setState((prev: any) => ({ ...prev, run: true, isRestart: false }))
    }

    console.groupCollapsed(type)
    console.groupEnd()
  }

  return (
    <TourContext.Provider
      value={{
        run,
        accordionOpen,
        steps,
        setState,
        stepIndex,
        handleJoyrideCallback,
        setStepIndex,
      }}
    >
      {children}
    </TourContext.Provider>
  )
}

export default TourContext
